if (!customElements.get('desson-sticky-cart')) {
  customElements.define('desson-sticky-cart', class DessonStickyCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector('.desson-sticky-cart__form');
      this.submitButton = this.querySelector('.desson-sticky-cart__submit');
      this.label = this.querySelector('[data-desson-sticky-label]');
      this.variantInput = this.querySelector('[data-desson-sticky-id]');
      this.variantText = this.querySelector('[data-desson-sticky-variant]');
      this.price = this.querySelector('[data-desson-sticky-price]');
      this.image = this.querySelector('.desson-sticky-cart__image');
      this.error = this.querySelector('[data-desson-sticky-error]');
      this.variants = JSON.parse(this.querySelector('[data-desson-sticky-variants]')?.textContent || '[]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.primaryButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`) || document.querySelector('.product-form__submit');
      this.footer = document.querySelector('#shopify-section-footer') || document.querySelector('footer');
      this.primaryPassed = false;
      this.footerVisible = false;
      this.form?.addEventListener('submit', this.onSubmit.bind(this));
      this.observePrimaryButton();
      this.observeFooter();
      this.subscribeToVariantChanges();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.footerObserver?.disconnect();
      if (typeof this.unsubscribeVariant === 'function') this.unsubscribeVariant();
    }

    observePrimaryButton() {
      if (!this.primaryButton) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.primaryPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.updateVisibility();
      }, { threshold: 0 });
      this.observer.observe(this.primaryButton);
    }

    observeFooter() {
      if (!this.footer) return;
      this.footerObserver = new IntersectionObserver(([entry]) => {
        this.footerVisible = entry.isIntersecting;
        this.updateVisibility();
      }, { threshold: 0 });
      this.footerObserver.observe(this.footer);
    }

    updateVisibility() {
      const visible = this.primaryPassed && !this.footerVisible;
      this.dataset.visible = String(visible);
      this.setAttribute('aria-hidden', String(!visible));
    }

    subscribeToVariantChanges() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId && event.data.sectionId !== this.sectionId) return;
        if (event?.data?.variant?.id) this.updateVariant(event.data.variant.id);
      });
    }

    updateVariant(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;
      this.variantInput.value = variant.id;
      this.price.textContent = variant.price;
      this.variantText.textContent = variant.title === 'Default Title' ? '' : variant.title;
      this.submitButton.disabled = !variant.available;
      this.label.textContent = variant.available ? (window.variantStrings?.addToCart || 'Add to cart') : (window.variantStrings?.soldOut || 'Sold out');
      if (this.image && variant.image) {
        this.image.src = variant.image;
        this.image.srcset = '';
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.submitButton.disabled) return;
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
      this.setLoading(true);
      this.showError();
      try {
        const formData = new FormData(this.form);
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        cartDrawer.setActiveElement?.(this.submitButton);
        const response = await fetch(`${routes.cart_add_url}`, config);
        const result = await response.json();
        if (result.status) {
          this.showError(result.description || result.message);
          return;
        }
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(result);
      } catch (error) {
        console.error(error);
        this.showError(window.cartStrings?.error || 'Cart could not be updated. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      this.submitButton.classList.toggle('is-loading', loading);
      this.submitButton.toggleAttribute('aria-disabled', loading);
    }

    showError(message = '') {
      this.error.hidden = !message;
      this.error.textContent = message;
    }
  });
}
